import { Stack, styled } from '@mui/material';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

const StackItem = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    minWidth: '191px',
    padding: '16px 24px',
    background: NEW_COLORS.BASE.WHITE,
    borderRadius: '8px',
    gap: '8px',
    maxHeight: '106px',
    minHeight: '106px',
    display: 'flex',
    justifyContent: 'center',
    border: '1px solid #DDE2E5',
  },
}));

const StackContainer = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    gap: '24px',
    flexWrap: 'nowrap',
    width: '100%',
    overflowX: 'auto',
    scrollSnapType: 'x mandatory',
    '::-webkit-scrollbar': {
      display: 'none',
    },
  },
}));

export { StackContainer, StackItem };
